import { useLocationContext } from '../context/LocationContext';
import type { PracticeCrm } from '../api/locationsApi';

export interface CrmLabels {
    crm: PracticeCrm;
    isAvEmr: boolean;
    /** Target system name shown in copy, e.g. "Advital" or "AV EMR". */
    system: string;
    user: string;
    users: string;
    userHeader: string;
    calendar: string;
    calendars: string;
    calendarHeader: string;
}

const GHL_LABELS: CrmLabels = {
    crm: 'ghl',
    isAvEmr: false,
    system: 'Advital',
    user: 'Advital user',
    users: 'Advital users',
    userHeader: 'ADVITAL USER',
    calendar: 'Advital calendar',
    calendars: 'Advital calendars',
    calendarHeader: 'ADVITAL CALENDAR',
};

const AV_EMR_LABELS: CrmLabels = {
    crm: 'av_emr',
    isAvEmr: true,
    system: 'AV EMR',
    user: 'AV EMR provider',
    users: 'AV EMR providers',
    userHeader: 'AV EMR PROVIDER',
    calendar: 'AV EMR service',
    calendars: 'AV EMR services',
    calendarHeader: 'AV EMR SERVICE',
};

export function crmLabels(crm: PracticeCrm | undefined): CrmLabels {
    return crm === 'av_emr' ? AV_EMR_LABELS : GHL_LABELS;
}

/** Labels for the mapping targets of the selected practice (GHL-backed Advital, or AV EMR). */
export function useCrmLabels(): CrmLabels {
    const { currentLocation } = useLocationContext();
    return crmLabels(currentLocation?.crm);
}

/**
 * Mapping pages that apply to a practice. Service mapping (GHL service → GHL calendar)
 * has no meaning when AV EMR is the CRM: appointment types map straight to AV EMR services.
 */
export function visibleEntityKeys<K extends string>(keys: K[], crm: PracticeCrm | undefined): K[] {
    return crm === 'av_emr' ? keys.filter(k => k !== 'services') : keys;
}
